export default function (table) {
  const $checkedInputsInGroup = table.find(
    'tr.level_1 .export-account-check input:checked'
  )

  return table
    .find('tr.level_0 .export-attachment i')
    .toggle($checkedInputsInGroup.length > 0)
}
